import { PERIODS, type PeriodKey } from '@/lib/scatter2d-helpers';
import type { BacktestOutput } from '@/lib/backtest';

interface Props {
  backtestData: BacktestOutput;
  activePeriod: PeriodKey;
  onPeriodChange: (period: PeriodKey) => void;
}

export function PeriodSelector({ backtestData, activePeriod, onPeriodChange }: Props) {
  const hasPeriods = backtestData.periods && Object.keys(backtestData.periods).length > 0;
  const activePeriodData = backtestData.periods?.[activePeriod];

  return (
    <div className="absolute top-2 right-3 z-10 flex items-center gap-1">
      <span className="text-[10px] text-gray-200 mr-1 font-medium">Backtest:</span>
      {PERIODS.map(p => (
        <button
          key={p.key}
          onClick={() => onPeriodChange(p.key)}
          className={`text-[10px] px-2 py-0.5 rounded font-semibold transition-colors ${
            activePeriod === p.key
              ? 'bg-gray-800 text-white'
              : 'bg-gray-100 text-gray-200 hover:bg-gray-200'
          } ${!hasPeriods && p.key !== '3yr' ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'}`}
          disabled={!hasPeriods && p.key !== '3yr'}
        >
          {p.label}
        </button>
      ))}
      {activePeriodData && (
        <span className="text-[9px] text-gray-200 ml-1">
          SPY {(activePeriodData.benchmark * 100).toFixed(0)}%
        </span>
      )}
    </div>
  );
}
